import { APP_PATHS } from "./paths";
import Landing from "../components/Landing/Landing";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";
import Home from "../components/Home/Home";
import PendingOrders from "../components/PendingOrders/PendingOrders";
import PricedOrders from "../components/PricedOrders/PricedOrders";
import PricedOrderItems from "../components/PricedOrders/PricedOrderListItem/PricedOrderItems/PricedOrderItems";
import Skus from "../components/Skus/Skus";
import NewSkus from "../components/NewSkus/NewSkus";
import RecommendedSkus from "../components/RecommendedSkus/RecommendedSkus";
import Bundles from "../components/Bundles/Bundles";
import SkuDetails from "../components/SkuDetails/SkuDetails";
import BundleDetails from "../components/BundleDetails/BundleDetails";
import Cart from "../components/Cart/Cart";
import Profile from "../components/Profile/Profile";
import PreviousOrders from "../components/Profile/PreviousOrders/PreviousOrders";
import Wallet from "../components/Profile/Wallet/Wallet";
import Promotions from "../components/Promotions/Promotions";
import VoiceOrder from "../components/VoiceOrder/VoiceOrder";

export const PUBLIC_ROUTES = [
  {
    path: APP_PATHS.LANDING.url,
    component: Landing,
  },
  {
    path: APP_PATHS.POLICY.url,
    component: PrivacyPolicy,
  },
];

export const PROTECTED_ROUTES = [
  {
    path: APP_PATHS.HOME.url,
    component: Home,
  },
  {
    path: APP_PATHS.PENDING_ORDERS.url,
    component: PendingOrders,
  },
  {
    path: APP_PATHS.PRICED_ORDERS.url,
    component: PricedOrders,
  },
  {
    path: APP_PATHS.PRICED_ORDER_ITEMS.url,
    component: PricedOrderItems,
  },
  {
    path: APP_PATHS.PROMOTIONS.url,
    component: Promotions,
  },
  {
    path: APP_PATHS.SKUS.url,
    component: Skus,
  },
  {
    path: APP_PATHS.NEW_SKUS.url,
    component: NewSkus,
  },
  {
    path: APP_PATHS.RECOMMENDED_SKUS.url,
    component: RecommendedSkus,
  },

  {
    path: APP_PATHS.BUNDLES.url,
    component: Bundles,
  },
  {
    path: APP_PATHS.SKU_DETAILS.url,
    component: SkuDetails,
  },
  {
    path: APP_PATHS.BUNDLE_DETAILS.url,
    component: BundleDetails,
  },
  {
    path: APP_PATHS.CART.url,
    component: Cart,
  },
  {
    path: APP_PATHS.VOICE_ORDER.url,
    component: VoiceOrder,
  },
  {
    path: APP_PATHS.PROFILE.url,
    component: Profile,
    subRoutes: [
      {
        path: APP_PATHS.WALLET.url,
        component: Wallet,
        isIndex: true,
      },
      {
        path: APP_PATHS.PREVIOUS_ORDERS.url,
        component: PreviousOrders,
      },
    ],
  },
];
